module.exports = __webpack_public_path__ + "static/media/nalog-1.48f00b9c.png";